/** @jsxImportSource @emotion/react */
import type React from 'react';
import {
  CheckYourEmail,
  CheckYourEmailSpan,
  FirstParagraph,
  FirstSection,
  FirstSectionParagraph,
  MailTo,
  Screen,
  SecondSectionParagraph,
  TopPart,
} from './waitlist-sent.styled';
import { VSpace } from '../../chat/settings/account/account-settings';
import type { LoginStepProps } from '../login-shell.types';

export const WaitlistSent: React.FC<LoginStepProps> = () => {
  return (
    <Screen data-testid="waitlist-sent-screen">
      <TopPart>
        <FirstParagraph>Request an invitation to Mailander</FirstParagraph>
      </TopPart>
      <VSpace $h={12} />
      <CheckYourEmail>
        {/* sent-email */}
        <img src="/sent-email.svg" alt="sent-email" />
        <FirstSection>
          <CheckYourEmailSpan>Check Your Email</CheckYourEmailSpan>
          <FirstSectionParagraph>
            We have received your request.
            <br />
            Please open the confirmation email and
            <br />
            click <span style={{ fontWeight: 700 }}>Confirm</span> to complete your
            <br />
            invitation.
          </FirstSectionParagraph>
        </FirstSection>
        <SecondSectionParagraph>
          If it does not arrive within a few minutes,
          <br />
          check your spam folder or reach me
          <br />
          at <MailTo href="mailto:chris@chrismailander.com">chris@chrismailander.com</MailTo>
        </SecondSectionParagraph>
      </CheckYourEmail>
    </Screen>
  );
};
